// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2756%27 height=%2756%27 viewBox=%270 0 56 56%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M27.051 21.7372L28.3294 23.0014L23.8904 27.4403L35.041 27.4403L35.041 29.2869L23.8904 29.2869L28.3294 33.7188L27.051 34.9901L20.4245 28.3636L27.051 21.7372Z%27 fill=%27white%27/%3E%3Ccircle cx=%2728%27 cy=%2728%27 r=%2727.5%27 transform=%27rotate%28180 28 28%29%27 stroke=%27white%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2756%27 height=%2756%27 viewBox=%270 0 56 56%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M28.949 34.2628L27.6706 32.9986L32.1096 28.5597H20.959V26.7131H32.1096L27.6706 22.2812L28.949 21.0099L35.5755 27.6364L28.949 34.2628Z%27 fill=%27white%27/%3E%3Ccircle cx=%2728%27 cy=%2728%27 r=%2727.5%27 stroke=%27white%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListingDetailsPage_detailPageWrapper__9mP-x {
  padding: 60px 0;
}

.ListingDetailsPage_listingGallery__cUOBh {
  position: relative;
  width: 100%;
  padding-top: 36%;
}
@media (max-width: 767px) {
  .ListingDetailsPage_listingGallery__cUOBh {
    padding-top: 54%;
  }
}
.ListingDetailsPage_listingGallery__cUOBh .ListingDetailsPage_allViewButton__8qO1C {
  position: absolute;
  bottom: 24px;
  left: 80px;
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 100px;
  line-height: 42px;
  padding: 0px 36px;
  background-color: #064749;
  color: #fff;
}
@media (max-width: 767px) {
  .ListingDetailsPage_listingGallery__cUOBh .ListingDetailsPage_allViewButton__8qO1C {
    bottom: 16px;
    left: 16px;
    line-height: 30px;
    font-size: 12px;
    padding: 0px 16px;
  }
}

.ListingDetailsPage_modalImages__xwmh4 .ListingDetailsPage_modalImage__vT4kv {
  position: relative;
  width: 100%;
  padding-top: 44%;
}
@media (max-width: 767px) {
  .ListingDetailsPage_modalImages__xwmh4 .ListingDetailsPage_modalImage__vT4kv {
    padding-top: 60%;
  }
}
.ListingDetailsPage_modalImages__xwmh4 .ListingDetailsPage_modalImage__vT4kv img, .ListingDetailsPage_modalImages__xwmh4 .ListingDetailsPage_modalImage__vT4kv embed {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
  object-fit: contain;
}

.ListingDetailsPage_closeModal__pWqwE {
  height: 24px;
  width: 24px;
  color: #fff;
  border-radius: 100px;
  margin-left: auto;
  margin-right: 24px;
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: -12px;
}
@media (max-width: 767px) {
  .ListingDetailsPage_closeModal__pWqwE {
    margin-right: 0;
    height: 20px;
    width: 20px;
    top: 8px;
    right: 8px;
  }
}
.ListingDetailsPage_closeModal__pWqwE svg {
  width: 100%;
  height: 100%;
}

.ListingDetailsPage_title__KoJmh {
  font-size: 36px;
  margin: 0 0 48px;
  text-align: center;
}

.ListingDetailsPage_listingGalleryWrapper__Qq1Sv {
  display: flex;
  gap: 8px;
  min-height: 180px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  text-align: center;
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 0.16);
  box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.06);
  padding: 8px;
}
@media (max-width: 767px) {
  .ListingDetailsPage_listingGalleryWrapper__Qq1Sv {
    padding: 3px;
    gap: 3px;
  }
}
.ListingDetailsPage_listingGalleryWrapper__Qq1Sv img, .ListingDetailsPage_listingGalleryWrapper__Qq1Sv embed {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid rgba(128, 128, 128, 0.16);
  box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.06);
}
.ListingDetailsPage_listingGalleryWrapper__Qq1Sv .ListingDetailsPage_firstColumn__TeYEp {
  width: 74%;
}
@media (max-width: 767px) {
  .ListingDetailsPage_listingGalleryWrapper__Qq1Sv .ListingDetailsPage_firstColumn__TeYEp {
    width: 70%;
  }
}
.ListingDetailsPage_listingGalleryWrapper__Qq1Sv .ListingDetailsPage_secondColumn__8Xtjw {
  width: 18%;
  display: flex;
  gap: 8px;
  flex-direction: column;
}
@media (max-width: 767px) {
  .ListingDetailsPage_listingGalleryWrapper__Qq1Sv .ListingDetailsPage_secondColumn__8Xtjw {
    width: 30%;
  }
}
.ListingDetailsPage_listingGalleryWrapper__Qq1Sv .ListingDetailsPage_thirdColumn__Ah6od {
  width: 18%;
  display: flex;
  gap: 8px;
  flex-direction: column;
}
@media (max-width: 767px) {
  .ListingDetailsPage_listingGalleryWrapper__Qq1Sv .ListingDetailsPage_thirdColumn__Ah6od {
    display: none;
  }
}
.ListingDetailsPage_listingGalleryWrapper__Qq1Sv .ListingDetailsPage_halfHeight__k9eYw {
  height: 50%;
}

.ListingDetailsPage_contentWrapper__W\\+Mg3 {
  display: flex;
  gap: 30px;
  margin: 48px 0;
  min-height: 300px;
}
@media (max-width: 1023px) {
  .ListingDetailsPage_contentWrapper__W\\+Mg3 {
    flex-direction: column;
  }
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_leftContents__7Rbe1 {
  width: calc(100% - 548px);
}
@media (max-width: 767px) {
  .ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_leftContents__7Rbe1 {
    width: 100%;
  }
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_leftContents__7Rbe1 .ListingDetailsPage_venueTag__xnk6F {
  display: flex;
  align-items: center;
  gap: 6px;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_leftContents__7Rbe1 .ListingDetailsPage_venueName__x6fCX {
  font-size: 18px;
  margin: 16px 0 36px;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_leftContents__7Rbe1 h2 {
  margin: 48px 0 36px;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_leftContents__7Rbe1 h3 {
  margin: 24px 0 16px;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_leftContents__7Rbe1 ul {
  list-style: unset;
  margin-left: 20px;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_leftContents__7Rbe1 ul li {
  margin-bottom: 6px;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_orderWrapper__\\+nzri {
  width: 500px;
  margin-left: 48px;
  background: rgb(242, 240, 242);
  padding: 24px;
  border-radius: 16px;
}
@media (max-width: 767px) {
  .ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_orderWrapper__\\+nzri {
    width: 100%;
    margin-left: 0;
  }
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_orderWrapper__\\+nzri h6 {
  font-size: 20px;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_orderWrapper__\\+nzri .ListingDetailsPage_orderContents__\\+vIZW {
  margin: 0 0 36px;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_orderWrapper__\\+nzri .ListingDetailsPage_priceContent__SaOLd {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_orderWrapper__\\+nzri .ListingDetailsPage_orderContent__rcx5S {
  display: flex;
  align-items: center;
  margin: 16px 0;
}
.ListingDetailsPage_contentWrapper__W\\+Mg3 .ListingDetailsPage_orderWrapper__\\+nzri .ListingDetailsPage_registeredText__JxNIG {
  text-align: center;
  margin: 16px 0;
}

/* availableAccessories */
.ListingDetailsPage_availableAccessories__xezxa {
  margin: 120px 0 0;
}
.ListingDetailsPage_availableAccessories__xezxa .ListingDetailsPage_accessoriesContents__Mwq6g {
  display: flex;
  gap: 30px;
  justify-content: space-between;
  flex-wrap: wrap;
}
@media (max-width: 1023) {
  .ListingDetailsPage_availableAccessories__xezxa .ListingDetailsPage_accessoriesContents__Mwq6g {
    justify-content: center;
  }
}
.ListingDetailsPage_availableAccessories__xezxa .ListingDetailsPage_accessoriesContents__Mwq6g .ListingDetailsPage_accessoriesColumn__WR88j {
  max-width: 280px;
  width: 100%;
}
.ListingDetailsPage_availableAccessories__xezxa .ListingDetailsPage_accessoriesContents__Mwq6g .ListingDetailsPage_accessoriesContent__kV7P7 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
.ListingDetailsPage_availableAccessories__xezxa .ListingDetailsPage_accessoriesContents__Mwq6g .ListingDetailsPage_accessoriesContent__kV7P7 h6 {
  font-size: 18px;
  font-weight: 500;
}

/* hospitalityWrapper */
.ListingDetailsPage_hospitalityWrapper__GOa2z {
  margin: 120px 0 0;
}
.ListingDetailsPage_hospitalityWrapper__GOa2z .ListingDetailsPage_hospitalityColumns__urXOX {
  display: flex;
  justify-content: space-between;
}
.ListingDetailsPage_hospitalityWrapper__GOa2z .ListingDetailsPage_hospitalityContents__0lV1T {
  margin-top: 36px;
}
.ListingDetailsPage_hospitalityWrapper__GOa2z .ListingDetailsPage_hospitalityContents__0lV1T .ListingDetailsPage_hospitalityContent__p5LPM {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

/* locationWrapper */
.ListingDetailsPage_locationWrapper__Jk751 {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin: 120px 0;
}
@media (max-width: 1023px) {
  .ListingDetailsPage_locationWrapper__Jk751 {
    flex-direction: column;
    align-items: flex-start;
  }
}
.ListingDetailsPage_locationWrapper__Jk751 .ListingDetailsPage_locationContents__wWiGm {
  max-width: 300px;
}
.ListingDetailsPage_locationWrapper__Jk751 .ListingDetailsPage_mapContents__ZYHLb {
  width: 50%;
}
@media (max-width: 1023px) {
  .ListingDetailsPage_locationWrapper__Jk751 .ListingDetailsPage_mapContents__ZYHLb {
    width: 100%;
  }
}
.ListingDetailsPage_locationWrapper__Jk751 .ListingDetailsPage_mapContents__ZYHLb img, .ListingDetailsPage_locationWrapper__Jk751 .ListingDetailsPage_mapContents__ZYHLb embed {
  width: 100%;
  height: 100%;
}
.ListingDetailsPage_locationWrapper__Jk751 .ListingDetailsPage_locationContent__o7aQ1 {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}
.ListingDetailsPage_locationWrapper__Jk751 .ListingDetailsPage_locationContent__o7aQ1 img, .ListingDetailsPage_locationWrapper__Jk751 .ListingDetailsPage_locationContent__o7aQ1 embed {
  width: 16px;
  height: 16px;
}
.ListingDetailsPage_locationWrapper__Jk751 .ListingDetailsPage_locationContent__o7aQ1 p {
  font-size: 20px;
}

.swiper-button-next {
  display: flex;
  border-radius: 100px;
  width: 56px !important;
  height: 56px !important;
  right: 42px;
  top: 46% !important;
  background: rgba(0, 0, 0, 0.2901960784);
  position: absolute;
  z-index: 10;
  cursor: pointer;
}
@media (max-width: 767px) {
  .swiper-button-next {
    width: 30px !important;
    height: 30px !important;
    right: 20px;
    top: 44% !important;
  }
}

.swiper-button-prev {
  display: flex;
  border-radius: 100px;
  width: 56px !important;
  height: 56px !important;
  left: 42px;
  top: 46% !important;
  background: rgba(0, 0, 0, 0.2901960784);
  position: absolute;
  z-index: 10;
  cursor: pointer;
}
@media (max-width: 767px) {
  .swiper-button-prev {
    width: 30px !important;
    height: 30px !important;
    left: 20px;
    top: 44% !important;
  }
}

.swiper-button-disabled {
  cursor: not-allowed;
  opacity: 0.5;
  display: none !important;
}

.swiper-button-prev::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: 56px;
  width: 56px;
  background-repeat: no-repeat;
  background-size: 57px;
}
@media (max-width: 767px) {
  .swiper-button-prev::after {
    height: 30px;
    width: 30px;
    background-size: 30px;
  }
}

.swiper-button-next::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  height: 56px;
  width: 56px;
}
@media (max-width: 767px) {
  .swiper-button-next::after {
    height: 30px;
    width: 30px;
    background-size: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/containers/ListingDetailsPage/ListingDetailsPage.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AACA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAEF;AADE;EAJF;IAKI,gBAAA;EAIF;AACF;AAHE;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EAAA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;AAKJ;AAJI;EAVF;IAWI,YAAA;IACA,UAAA;IACA,iBAAA;IACA,eAAA;IACA,iBAAA;EAOJ;AACF;;AAHE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AAMJ;AALI;EAJF;IAKI,gBAAA;EAQJ;AACF;AAPI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AASN;;AALA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;AAQF;AAPE;EAXF;IAYI,eAAA;IACA,YAAA;IACA,WAAA;IACA,QAAA;IACA,UAAA;EAUF;AACF;AATE;EACE,WAAA;EACA,YAAA;AAWJ;;AARA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAWF;;AATA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACE,2CAAA;EACF,4CAAA;EACA,YAAA;AAYF;AAXE;EAdF;IAeI,YAAA;IACA,QAAA;EAcF;AACF;AAbE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACE,2CAAA;EACF,4CAAA;AAeJ;AAZE;EACE,UAAA;AAcJ;AAbI;EAFF;IAGI,UAAA;EAgBJ;AACF;AAdE;EACE,UAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;AAgBJ;AAfI;EALF;IAMI,UAAA;EAkBJ;AACF;AAhBE;EACE,UAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;AAkBJ;AAjBI;EALF;IAMI,aAAA;EAoBJ;AACF;AAlBE;EACE,WAAA;AAoBJ;;AAjBA;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;AAoBF;AAnBE;EALF;IAMI,sBAAA;EAsBF;AACF;AArBE;EACE,yBAAA;AAuBJ;AAtBI;EAFF;IAGI,WAAA;EAyBJ;AACF;AAxBI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA0BN;AAxBI;EACE,eAAA;EACA,mBAAA;AA0BN;AAxBI;EACE,mBAAA;AA0BN;AAxBI;EACE,mBAAA;AA0BN;AAxBI;EACE,iBAAA;EACA,iBAAA;AA0BN;AAzBM;EACE,kBAAA;AA2BR;AAvBE;EACE,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AAyBJ;AAxBI;EANF;IAOI,WAAA;IACA,cAAA;EA2BJ;AACF;AA1BI;EACE,eAAA;AA4BN;AA1BI;EACE,gBAAA;AA4BN;AA1BI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA4BN;AA1BI;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AA4BN;AA1BI;EACE,kBAAA;EACA,cAAA;AA4BN;;AAvBA,yBAAA;AACA;EACE,iBAAA;AA0BF;AAzBE;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,eAAA;AA2BJ;AA1BI;EALF;IAMI,uBAAA;EA6BJ;AACF;AA5BI;EACE,gBAAA;EACA,WAAA;AA8BN;AA5BI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AA8BN;AA7BM;EACE,eAAA;EACA,gBAAA;AA+BR;;AA1BA,uBAAA;AACA;EACE,iBAAA;AA6BF;AA5BE;EACE,aAAA;EACA,8BAAA;AA8BJ;AA5BE;EACE,gBAAA;AA8BJ;AA7BI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA+BN;;AA3BA,oBAAA;AACA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;AA8BF;AA7BE;EALF;IAMI,sBAAA;IACA,uBAAA;EAgCF;AACF;AA/BE;EACE,gBAAA;AAiCJ;AA/BE;EACE,UAAA;AAiCJ;AAhCI;EAFF;IAGI,WAAA;EAmCJ;AACF;AAlCI;EACE,WAAA;EACA,YAAA;AAoCN;AAjCE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAmCJ;AAlCI;EACE,WAAA;EACA,YAAA;AAoCN;AAlCI;EACE,eAAA;AAoCN;;AAhCA;EACE,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAmCF;AAlCE;EAXF;IAYI,sBAAA;IACA,uBAAA;IACA,WAAA;IACA,mBAAA;EAqCF;AACF;;AAnCA;EACE,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;EACA,uCAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAsCF;AArCE;EAXF;IAYI,sBAAA;IACA,uBAAA;IACA,UAAA;IACA,mBAAA;EAwCF;AACF;;AAtCA;EACE,mBAAA;EACA,YAAA;EACA,wBAAA;AAyCF;;AAvCA;EACE,WAAA;EACA,yDAAA;EACA,YAAA;EACA,WAAA;EACA,4BAAA;EACA,qBAAA;AA0CF;AAzCE;EAPF;IAQI,YAAA;IACA,WAAA;IACA,qBAAA;EA4CF;AACF;;AA1CA;EACE,WAAA;EACA,yDAAA;EACA,YAAA;EACA,WAAA;AA6CF;AA5CE;EALF;IAMI,YAAA;IACA,WAAA;IACA,qBAAA;EA+CF;AACF","sourcesContent":[".detailPageWrapper {\n  padding: 60px 0;\n}\n.listingGallery {\n  position: relative;\n  width: 100%;\n  padding-top: 36%;\n  @media (max-width: 767px) {\n    padding-top: 54%;\n  }\n  & .allViewButton {\n    position: absolute;\n    bottom: 24px;\n    left: 80px;\n    width: fit-content;\n    border-radius: 100px;\n    line-height: 42px;\n    padding: 0px 36px;\n    background-color: #064749;\n    color: #fff;\n    @media (max-width: 767px) {\n      bottom: 16px;\n      left: 16px;\n      line-height: 30px;\n      font-size: 12px;\n      padding: 0px 16px;\n    }\n  }\n}\n.modalImages {\n  & .modalImage {\n    position: relative;\n    width: 100%;\n    padding-top: 44%;\n    @media (max-width: 767px) {\n      padding-top: 60%;\n    }\n    & img, & embed {\n      width: 100%;\n      height: 100%;\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0;\n      right: 0;\n      text-align: center;\n      object-fit: contain;\n    }\n  }\n}\n.closeModal {\n  height: 24px;\n  width: 24px;\n  color: #fff;\n  border-radius: 100px;\n  margin-left: auto;\n  margin-right: 24px;\n  cursor: pointer;\n  position: absolute;\n  top: 12px;\n  right: -12px;\n  @media (max-width: 767px) {\n    margin-right: 0;\n    height: 20px;\n    width: 20px;\n    top: 8px;\n    right: 8px;\n  }\n  & svg {\n    width: 100%;\n    height: 100%;\n  }\n}\n.title {\n  font-size: 36px;\n  margin: 0 0 48px;\n  text-align: center;\n}\n.listingGalleryWrapper {\n  display: flex;\n  gap: 8px;\n  min-height: 180px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  text-align: center;\n  border-radius: 8px;\n    border: 1px solid rgb(128 128 128 / 16%);\n  box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.06);\n  padding: 8px;\n  @media (max-width: 767px) {\n    padding: 3px;\n    gap: 3px;\n  }\n  & img, & embed {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 8px;\n      border: 1px solid rgb(128 128 128 / 16%);\n    box-shadow: 0 8px 14px 0 rgba(0, 0, 0, 0.06);\n\n  }\n  & .firstColumn {\n    width: 74%;\n    @media (max-width: 767px) {\n      width: 70%;\n    }\n  }\n  & .secondColumn {\n    width: 18%;\n    display: flex;\n    gap: 8px;\n    flex-direction: column;\n    @media (max-width: 767px) {\n      width: 30%;\n    }\n  }\n  & .thirdColumn {\n    width: 18%;\n    display: flex;\n    gap: 8px;\n    flex-direction: column;\n    @media (max-width: 767px) {\n      display: none;\n    }\n  }\n  & .halfHeight {\n    height: 50%;\n  }\n}\n.contentWrapper {\n  display: flex;\n  gap: 30px;\n  margin: 48px 0;\n  min-height: 300px;\n  @media (max-width: 1023px) {\n    flex-direction: column;\n  }\n  & .leftContents {\n    width: calc(100% - 548px);\n    @media (max-width: 767px) {\n      width: 100%;\n    }\n    & .venueTag {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n    }\n    & .venueName {\n      font-size: 18px;\n      margin: 16px 0 36px;\n    }\n    & h2 {\n      margin: 48px 0 36px;\n    }\n    & h3 {\n      margin: 24px 0 16px;\n    }\n    & ul {\n      list-style: unset;\n      margin-left: 20px;\n      & li {\n        margin-bottom: 6px;\n      }\n    }\n  }\n  & .orderWrapper {\n    width: 500px;\n    margin-left: 48px;\n    background: rgb(242 240 242);\n    padding: 24px;\n    border-radius: 16px;\n    @media (max-width: 767px) {\n      width: 100%;\n      margin-left: 0;\n    }\n    & h6 {\n      font-size: 20px;\n    }\n    & .orderContents {\n      margin: 0 0 36px;\n    }\n    & .priceContent {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 24px;\n    }\n    & .orderContent {\n      display: flex;\n      align-items: center;\n      margin: 16px 0;\n    }\n    & .registeredText {\n      text-align: center;\n      margin: 16px 0;\n    }\n  }\n}\n\n/* availableAccessories */\n.availableAccessories {\n  margin: 120px 0 0;\n  & .accessoriesContents {\n    display: flex;\n    gap: 30px;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    @media (max-width: 1023) {\n      justify-content: center;\n    }\n    & .accessoriesColumn {\n      max-width: 280px;\n      width: 100%;\n    }\n    & .accessoriesContent {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 24px;\n      & h6 {\n        font-size: 18px;\n        font-weight: 500;\n      }\n    }\n  }\n}\n/* hospitalityWrapper */\n.hospitalityWrapper {\n  margin: 120px 0 0;\n  .hospitalityColumns {\n    display: flex;\n    justify-content: space-between;\n  }\n  & .hospitalityContents {\n    margin-top: 36px;\n    .hospitalityContent {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      margin-bottom: 12px;\n    }\n  }\n}\n/* locationWrapper */\n.locationWrapper {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin: 120px 0;\n  @media (max-width: 1023px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  & .locationContents {\n    max-width: 300px;\n  }\n  & .mapContents {\n    width: 50%;\n    @media (max-width: 1023px) {\n      width: 100%;\n    }\n    & img, & embed {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  & .locationContent {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    margin-bottom: 16px;\n    & img, & embed {\n      width: 16px;\n      height: 16px;\n    }\n    & p {\n      font-size: 20px;\n    }\n  }\n}\n:global(.swiper-button-next) {\n  display: flex;\n  border-radius: 100px;\n  width: 56px !important;\n  height: 56px !important;\n  right: 42px;\n  top: 46% !important;\n  background: #0000004a;\n  position: absolute;\n  z-index: 10;\n  cursor: pointer;\n  @media (max-width: 767px) {\n    width: 30px !important;\n    height: 30px !important;\n    right: 20px;\n    top: 44% !important;\n  }\n}\n:global(.swiper-button-prev) {\n  display: flex;\n  border-radius: 100px;\n  width: 56px !important;\n  height: 56px !important;\n  left: 42px;\n  top: 46% !important;\n  background: #0000004a;\n  position: absolute;\n  z-index: 10;\n  cursor: pointer;\n  @media (max-width: 767px) {\n    width: 30px !important;\n    height: 30px !important;\n    left: 20px;\n    top: 44% !important;\n  }\n}\n:global(.swiper-button-disabled) {\n  cursor: not-allowed;\n  opacity: 0.5;\n  display: none !important;\n}\n:global(.swiper-button-prev::after) {\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3Csvg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M27.051 21.7372L28.3294 23.0014L23.8904 27.4403L35.041 27.4403L35.041 29.2869L23.8904 29.2869L28.3294 33.7188L27.051 34.9901L20.4245 28.3636L27.051 21.7372Z' fill='white'/%3E%3Ccircle cx='28' cy='28' r='27.5' transform='rotate(180 28 28)' stroke='white'/%3E%3C/svg%3E%0A\");\n  height: 56px;\n  width: 56px;\n  background-repeat: no-repeat;\n  background-size: 57px;\n  @media (max-width: 767px) {\n    height: 30px;\n    width: 30px;\n    background-size: 30px;\n  }\n}\n:global(.swiper-button-next::after) {\n  content: \"\";\n  background-image: url(\"data:image/svg+xml,%3Csvg width='56' height='56' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M28.949 34.2628L27.6706 32.9986L32.1096 28.5597H20.959V26.7131H32.1096L27.6706 22.2812L28.949 21.0099L35.5755 27.6364L28.949 34.2628Z' fill='white'/%3E%3Ccircle cx='28' cy='28' r='27.5' stroke='white'/%3E%3C/svg%3E%0A\");\n  height: 56px;\n  width: 56px;\n  @media (max-width: 767px) {\n    height: 30px;\n    width: 30px;\n    background-size: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"detailPageWrapper": `ListingDetailsPage_detailPageWrapper__9mP-x`,
	"listingGallery": `ListingDetailsPage_listingGallery__cUOBh`,
	"allViewButton": `ListingDetailsPage_allViewButton__8qO1C`,
	"modalImages": `ListingDetailsPage_modalImages__xwmh4`,
	"modalImage": `ListingDetailsPage_modalImage__vT4kv`,
	"closeModal": `ListingDetailsPage_closeModal__pWqwE`,
	"title": `ListingDetailsPage_title__KoJmh`,
	"listingGalleryWrapper": `ListingDetailsPage_listingGalleryWrapper__Qq1Sv`,
	"firstColumn": `ListingDetailsPage_firstColumn__TeYEp`,
	"secondColumn": `ListingDetailsPage_secondColumn__8Xtjw`,
	"thirdColumn": `ListingDetailsPage_thirdColumn__Ah6od`,
	"halfHeight": `ListingDetailsPage_halfHeight__k9eYw`,
	"contentWrapper": `ListingDetailsPage_contentWrapper__W+Mg3`,
	"leftContents": `ListingDetailsPage_leftContents__7Rbe1`,
	"venueTag": `ListingDetailsPage_venueTag__xnk6F`,
	"venueName": `ListingDetailsPage_venueName__x6fCX`,
	"orderWrapper": `ListingDetailsPage_orderWrapper__+nzri`,
	"orderContents": `ListingDetailsPage_orderContents__+vIZW`,
	"priceContent": `ListingDetailsPage_priceContent__SaOLd`,
	"orderContent": `ListingDetailsPage_orderContent__rcx5S`,
	"registeredText": `ListingDetailsPage_registeredText__JxNIG`,
	"availableAccessories": `ListingDetailsPage_availableAccessories__xezxa`,
	"accessoriesContents": `ListingDetailsPage_accessoriesContents__Mwq6g`,
	"accessoriesColumn": `ListingDetailsPage_accessoriesColumn__WR88j`,
	"accessoriesContent": `ListingDetailsPage_accessoriesContent__kV7P7`,
	"hospitalityWrapper": `ListingDetailsPage_hospitalityWrapper__GOa2z`,
	"hospitalityColumns": `ListingDetailsPage_hospitalityColumns__urXOX`,
	"hospitalityContents": `ListingDetailsPage_hospitalityContents__0lV1T`,
	"hospitalityContent": `ListingDetailsPage_hospitalityContent__p5LPM`,
	"locationWrapper": `ListingDetailsPage_locationWrapper__Jk751`,
	"locationContents": `ListingDetailsPage_locationContents__wWiGm`,
	"mapContents": `ListingDetailsPage_mapContents__ZYHLb`,
	"locationContent": `ListingDetailsPage_locationContent__o7aQ1`
};
export default ___CSS_LOADER_EXPORT___;
